import { useEffect, useState } from "react";
import styles from "./incomeList.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { TableLoader } from "../../../../../components/LoaderC";
import ListFilters from "./components/ListFilters";
import ListRecords from "./components/ListRecords";
import ListDonutWidget from "./components/ListDonutWidget";
import dayjs from "dayjs";

const IncomeList = ({ handleView }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [contentLoading, setContentLoading] = useState(true);
  const [filterOpen, setFilterOpen] = useState(false);
  const [allData, setAllData] = useState([]);
  const [incomeCategories, setIncomeCategories] = useState([]);
  const [filterredData, setFilterredData] = useState([]);
  const [currentFilterValue, setCurrentFilterValue] = useState("");
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(-1);
  const [filterData, setFilterData] = useState({ searchKey: "", property: "", apartment: "", payment_status: "", view: "", last_payment_date: null, category: "", rent_month_text: '', rent_month: '' });
  const [propertyList, setPropertyList] = useState([]);
  const [donutGraphData, setDonutGraphData] = useState([]);
  const [apartmentList, setApartmentList] = useState([]);

  useEffect(() => {
    const fetchAllProperties = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        let propertyData = response.data.data;

        propertyData = [{ value: "all", label: "All", apartments: [] }].concat(propertyData);
        setPropertyList(propertyData);

        if (localStorage.getItem("propertyFilterData")) {
          let filterPropertyId = localStorage.getItem("propertyFilterData");
          localStorage.removeItem("propertyFilterData");

          setFilterData((prev) => {
            return { ...prev, property: parseInt(filterPropertyId) };
          });

          let apartmentListTemp = [];
          propertyData?.map((i) => {
            if (i.value === parseInt(filterPropertyId)) {
              apartmentListTemp = i.apartments;
            }
            return null;
          });

          apartmentListTemp = [{ value: "all", label: "All", apartments: [] }].concat(apartmentListTemp);
          setApartmentList(apartmentListTemp);
        }

        if (localStorage.getItem("apartmentFilterData")) {
          let apartmentFilter = localStorage.getItem("apartmentFilterData");
          localStorage.removeItem("apartmentFilterData");
          apartmentFilter = parseInt(apartmentFilter);

          setFilterData((prev) => {
            return { ...prev, apartment: parseInt(apartmentFilter) };
          });
        }
      });
    };
    fetchAllProperties();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    /*async function getAllData() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/incomes", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    }*/
    getAllData();
  }, [getAccessTokenSilently]);

  const getAllData = async (pageNo = 1) => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios(process.env.REACT_APP_PAYMENT_API_URL + `v1/incomes?page=${pageNo}&limit=25`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setContentLoading(false);

      const newData = response.data.data;

      setAllData(prev => pageNo === 1 ? newData : [...prev, ...newData]);

      if (response.data.has_more) {
        getAllData(pageNo + 1);
      }

    }).catch(() => {
      setContentLoading(false);
    });
  }

  useEffect(() => {
    let filterredDataTemp = allData;

    if (filterData.searchKey !== "") {
      let inputVal = filterData.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredDataTemp = filterredDataTemp.filter((item) => {
        return (item.tenant_name.toLowerCase().includes(inputVal) || item.property_name.toLowerCase().includes(inputVal) || item.apt_no.toLowerCase().includes(inputVal) || item.formatted_amount.toLowerCase().includes(inputVal));
      });
    }

    if (filterData.property !== "" && filterData.property !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => i.property_id === filterData.property);
    }

    if (filterData.apartment !== "" && filterData.apartment !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => i.apt_id === filterData.apartment);
    }

    if (filterData.category && filterData.category !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => {
        return i.categories?.some((cat) => cat.id === filterData.category);
      });
    }

    if (filterData.view !== "" && filterData.view !== "all") {
      if (filterData.view === "active") {
        filterredDataTemp = filterredDataTemp.filter((i) => i.is_archived === 0);
      }
      if (filterData.view === "archived") {
        filterredDataTemp = filterredDataTemp.filter((i) => i.is_archived === 1);
      }
    }

    if (filterData.payment_status !== "" && filterData.payment_status !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => i.payment_status === filterData.payment_status);
    }

    if (filterData.last_payment_date && filterData.last_payment_date !== "") {
      filterredDataTemp = filterredDataTemp.filter((i) => {
        var dateR = filterData.last_payment_date;
        if (dayjs(dayjs(i.date).format("YYYY-MM-DD")).isBetween(dayjs(dateR[0]).format("YYYY-MM-DD"), dayjs(dateR[1]).format("YYYY-MM-DD"), undefined, [])) {
          return true;
        }
        return false;
      });
    }

    if (filterData.rent_month_text && filterData.rent_month_text !== "") {
      filterredDataTemp = filterredDataTemp.filter((i) => i?.rent_bill_date?.indexOf(filterData.rent_month_text) > -1);
    }

    setFilterredData(filterredDataTemp);
  }, [allData, filterData]);

  useEffect(() => {
    getDonutGraphData("");
  }, [getAccessTokenSilently]);

  useEffect(() => {
    const buildUrl = () => {
      if (currentFilterValue === "search" || currentFilterValue === "payment_status")
        return;
      const queryParams = [];

      if (filterData.property && filterData.property !== "all") {
        queryParams.push(`property_id=${filterData.property}`);
      }

      if (filterData.apartment && filterData.apartment !== "all") {
        queryParams.push(`apt_id=${filterData.apartment}`);
      }

      if (Array.isArray(filterData.last_payment_date) && filterData.last_payment_date.length === 2) {
        const start = filterData.last_payment_date[0]?.toLocaleDateString("en-CA");
        const end = filterData.last_payment_date[1]?.toLocaleDateString("en-CA");

        queryParams.push(`start=${start}`);
        queryParams.push(`end=${end}`);
      }

      if (filterData.category && filterData.category !== "all") {
        queryParams.push(`category_id=${filterData.category}`);
      }

      if (filterData.rent_month && filterData.rent_month !== "all") {
        queryParams.push(`rent_month=${filterData.rent_month}`);
      }

      let queryParamsUrl = "";

      if (queryParams.length) {
        queryParamsUrl = `?${queryParams.join("&")}`;
      }

      getDonutGraphData(queryParamsUrl);
    };

    if (currentFilterValue) {
      buildUrl();
    }
  }, [currentFilterValue, filterData]);

  useEffect(() => {
    const getCategoryList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/income-categories", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setIncomeCategories([{ title: "All", id: "all" }, ...response.data.data]);

        if (localStorage.getItem("incomeCategoryFilterData")) {
          let categoryFilter = localStorage.getItem("incomeCategoryFilterData");
          localStorage.removeItem("incomeCategoryFilterData");
          categoryFilter = parseInt(categoryFilter);

          setFilterData((prev) => {
            return { ...prev, category: parseInt(categoryFilter) };
          });

          setCurrentFilterValue("category");
        }
      }).catch(() => { });
    };

    getCategoryList();
  }, [getAccessTokenSilently]);

  const selectProperty = (e) => {
    let apartmentListTemp = [];
    propertyList?.map((i) => {
      if (i.value === e) {
        apartmentListTemp = i.apartments;
      }
      return null;
    });

    apartmentListTemp = [{ value: "all", label: "All", apartments: [] }].concat(apartmentListTemp);
    setApartmentList(apartmentListTemp);
  };

  async function getDonutGraphData(queryParams) {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    let url = process.env.REACT_APP_PAYMENT_API_URL + "v1/income-data";

    if (queryParams) {
      url = url + queryParams;
    }
    axios(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setDonutGraphData(response.data.data);
    }).catch((error) => { });
  }

  return (<div className={`${styles.BodyCon}`}>
    <div className={`${styles.mainCardDiv}`}>
      <div className={`${styles.mainCard}`}>
        <div className="control-pane">
          {contentLoading && (<div className="Loader TableLoader">
            <TableLoader />
          </div>)}

          <div className={`${styles.Row}`}>
            {!contentLoading && (<>
              <ListFilters
                setPage={setPage.bind(this)}
                setFilterData={setFilterData}
                setFilterOpen={setFilterOpen}
                filterOpen={filterOpen}
                filterData={filterData}
                selectProperty={selectProperty}
                propertyList={propertyList}
                apartmentList={apartmentList}
                handleView={handleView}
                setCurrentFilterValue={setCurrentFilterValue}
                incomeCategories={incomeCategories}
              />

              <div className={`${styles.IncomeListingBody}`}>
                <div className={`${styles.IncomeListSec}`}>
                  {/* {filterredData.map((item, index) => {
                        return perPage === -1 ||
                          (index >= page * perPage &&
                            index < page * perPage + perPage) ? (
                          <ListCards item={item} index={index} />
                        ) : null;
                      })} */}

                  {filterredData.length > 0 && (<ListRecords
                    filterredData={filterredData}
                    filterData={filterData}
                    perPage={perPage}
                    page={page}
                  />)}

                  {filterredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                    <div className={`${styles.NoDataIMG}`}>
                      <img src="/static/img/no-income.png" alt="No Data" />
                    </div>
                    <p className={`${styles.NoDataText}`}>Income list is currently empty.</p>
                    <p className={`${styles.NoDataTextSub}`}>All your income entries will appear here once available.</p>
                  </div>)}
                </div>

                <div className={`${styles.IncomeGraphSec}`}>
                  <ListDonutWidget donutGraphData={donutGraphData} />
                </div>
              </div>

              {/* {filterredData.length > 0 && (<div className="Pagination TablePaginationNew ">
                <TablePagination
                  count={filterredData.length}
                  color="primary"
                  page={page}
                  rowsPerPage={perPage}
                  onPageChange={(e, v) => setPage(v)}
                  rowsPerPageOptions={[
                    { label: "4", value: 4 },
                    { label: "8", value: 8 },
                    { label: "16", value: 16 },
                    { label: "All", value: -1 },
                  ]}
                  onRowsPerPageChange={(e) => {
                    setPage(0);
                    setPerPage(e.target.value);
                  }}
                  labelRowsPerPage={"Payments per Page:"}
                />
              </div>)} */}
            </>)}
          </div>
        </div>
      </div>
    </div>
  </div>);
};

export default IncomeList;